import './App.css';
import UsersList from './components/userlist/UsersList';
import useUsers from './hooks/useUsers';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import EditUser from './components/EditUser';
import AddUser from './components/AddUser';
import Facturacion from './components/Facturacion';
import CasosExito from './components/Clientes';
import Legal from './components/Legal';
import Comercializacion from './components/Comercializacion';
import Consultoria from './components/Consultoria';
import Nosotros from './components/Nosotros';
import Servicios from './components/Servicios';
import Login from './components/Login';
import Alubin from './components/Clientes-Casos/Alubin';
import CUETARA from './components/Clientes-Casos/CUETARA';
import FARMACOS from './components/Clientes-Casos/FARMACOS-DAROVI';
import IMMSA from './components/Clientes-Casos/IMMSA';
import LAPALOMA from './components/Clientes-Casos/La-Paloma';
import NICRO from './components/Clientes-Casos/NICRO';
import Register from './components/Registrer';
import Home from './components/Home'; 
import Profile from './components/Profile';
import Computadoras from './components/Catalogos/Computadoras';
import Perifericos from './components/Catalogos/Perifericos';
import ComponentesHardware from './components/Catalogos/ComponentesHardware';
import Almacenamiento from './components/Catalogos/Almacenamiento';
import Redes from './components/Catalogos/Redes';
import Suministros from './components/Catalogos/Suministros';

import fondoDecorativo from './assets/images/IAUTOMATIZA CFDI.png';
import GestionIcon from './assets/images/Gestion.png';
import AgilizaIcon from './assets/images/Agiliza1.png';
import DesicionesIcon from './assets/images/Desiciones2.png';
import ReducirIcon from './assets/images/Reducir.png';
import GeneraIcon from './assets/images/Genera2.png';
import TiempoIcon from './assets/images/Tiempo.png';
import Grafica from './assets//images/Grafica.png';
import videoDecorativo from './assets/images/Video.mp4';
import Facebok from './assets/images/Facebok.png';
import Wasa from './assets/images/Wasa.png';
import insta from './assets/images/insta.png';
import Ubi from './assets/images/Ubi.png';
import Telefono from './assets/images/Telefono.png';
import Email34 from './assets/images/Correo.png';
import RedesFondo from './assets/images/Red-Neuronal.png';
import checkAnim from './assets/images/check.gif';
import RedNeuronal2 from './assets/images/Red-Neuronal4.png';
import usePageTracking from './hooks/usePageTracking';
import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import Sistemas from './components/Sistemas';

function App() {
  usePageTracking();
  const { users, deleteUser } = useUsers();

  const extraTextRef = useRef(null);
  const textBlockRef = useRef(null);
  const [showAnimations, setShowAnimations] = useState(false);
  const [showTextBlockAnimation, setShowTextBlockAnimation] = useState(false);


const location = useLocation();

useEffect(() => {
  setShowAnimations(false);
  setShowTextBlockAnimation(false);
}, [location.pathname]);

useEffect(() => {
  if (!extraTextRef.current) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        setShowAnimations(true);
      }
    },
    { threshold: 0.3 }
  );

  observer.observe(extraTextRef.current);

  return () => observer.disconnect();
}, [extraTextRef.current, location.pathname]); // 👈 importante agregar location

useEffect(() => {
  if (!textBlockRef.current) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        setShowTextBlockAnimation(true);
      }
    },
    { threshold: 0.3 }
  );

  observer.observe(textBlockRef.current);

  return () => observer.disconnect();
}, [textBlockRef.current, location.pathname]); // 👈 también aquí



  const handleEdit = (usuario) => {
    window.location.href = `/edit/${usuario.id}`;
  };

  const handleDelete = async (userId) => {
    try {
      const response = await fetch(`http://127.0.0.1:5000/users/${userId}`, { method: 'DELETE' });
      if (!response.ok) throw new Error("Error al eliminar el usuario");
      deleteUser(userId);
    } catch (error) {
      console.error(error);
    }
  };

  const scrollToExtraText = () => {
    extraTextRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const [enviado, setEnviado] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;

    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
    }).then(() => {
      setEnviado(true);
      form.reset();
      // Opcional: volver a mostrar formulario después de 5s
      // setTimeout(() => setEnviado(false), 5000);
    });
  };

  function PaginaCaso() {
  const { id } = useParams();

  const componentes = {
    Alubin: <Alubin />,
    IMMSA: <IMMSA />,
    CUETARA: <CUETARA />,
    LAPALOMA: <LAPALOMA />,
    NICRO: <NICRO />,
    FARMACOS: <FARMACOS />
  };

  const componente = componentes[id];

  return componente ? componente : <h2 style={{ textAlign: 'center' }}>Caso no encontrado</h2>;
}

function PaginaCatalogo() {
  const { id } = useParams();

const catalogos = {
  Computadoras: <Computadoras />,
  Perifericos: <Perifericos />,
  Hardware: <ComponentesHardware />,
   Almacenamiento: <Almacenamiento />,
   Redes: <Redes/>,
   Suministros: <Suministros/>,
};

const catalogo = catalogos[id];
  return catalogo ? catalogo : <h2 style={{ textAlign: 'center' }}>Catalogo pendiente</h2>;
}

  return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/" element={<Home />}>
          <Route 
            index 
            element={
              <>
                {/*Bloque video principal*/}
                <div className="coming-soon-container">
                  <div className="coming-soon-text">
                    <h1 >
                      {/*Titulo Sección Inicio */}
                       <span className="titulo-azul-destacada">IA</span>utomatiza <span className="titulo-azul-destacada">CFDI</span> <span className="titulo-azul-destacada-cloud">Cloud</span>
 
                    </h1>
                    {/*Descripcion Seccion Inicio */}
                    <h2>
                      AGILIZA Y AUTOMATIZA LOS PROCESOS <br />
                      DE LOS CFDI DE TU EMPRESA Y CONSIGUE <br />
                      AHORRAR TIEMPO Y COSTOS.
                    </h2>

                  
                  </div>
                  {/*Descripción Sección Inicio */}
                  <div className="coming-soon-image">
  <video autoPlay muted loop playsInline>
    {/* Video de fondo en la sección de inicio */}
    <source src={videoDecorativo} type="video/mp4" />
    Tu navegador no soporta la etiqueta de video.
  </video>
</div>

                </div>
{/*Bloque introducción*/}
<div style={{
  height: '300px',
  backgroundColor: '#e8e8e8',
  width: '100%',
  boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
  zIndex: 10,
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'hidden'
}}>
  {/* Imagen decorativa encima del fondo blanco */}
  <img
    src={RedNeuronal2}
    alt="red neuronal decorativa"
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      zIndex: 0,
      pointerEvents: 'none'
    }}
  />

  {/* Contenido encima de la imagen */}
  <div style={{ zIndex: 1 }}>
    {/*Descripción Sección Inicio 2 */}
    <p className="texto-banner">
  IAutomatiza CFDI es un sistema desarrollado en la nube para la descarga automática, administración y análisis de datos del CFDI. Nuestro sistema te proporciona información actualizada que te ayudará en la toma de decisiones de tu grupo empresarial. Garantiza seguridad y agilidad en la plataforma para gestionar de forma integral todas las operaciones que hayas generado ante el SAT. Confía en IAutomatiza CFDI Cloud para transformar la gestión fiscal de tu grupo empresarial.
</p>


  
  </div>
</div>


                {/* Bloque Generales */}
                <div 
                  ref={extraTextRef}
                  className="extra-menu-box"
                  style={{
                    backgroundColor: '#ffffff',
                    color: '#222',
                    padding: '10px 30px',
                    textAlign: 'center',
                  }}
                >
                  <div 
                    ref={textBlockRef} 
                    className={`text-block ${showTextBlockAnimation ? 'visible' : ''}`}
                    style={{ marginBottom: '30px' }}
                  >
                    {/*Titulo Generales*/}
                    <h2 className="gradient-title">¿Porqué elegir IAutomatiza CFDI?</h2>
                     {/* <p className="gradient-text">
                      IAutomatiza CFDI es un sistema que ha sido diseñado para gestionar los archivos CFDI de tu empresa, tanto a nivel emitidos como recibidos. 
                      Podrás ganar precisión y agilidad en tu gestión financiera y en tu gestión fiscal, con información en tiempo real y obteniendo una visión global de tu compañía.
                    </p>  */}
                  </div>

                  <div
  className="menu-item-container"
                    style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(3, 1fr)',
                      gap: '30px',
                      marginTop: '50px',
                      justifyItems: 'center',
                      alignItems: 'center',
                    }}
                  >
                    {/* Items Generales */}
                    <div className={`menu-item ${showAnimations ? 'visible' : ''}`} style={{ textAlign: 'center' }}>
                      <img src={GestionIcon} alt="Gestion" style={{ width: '130px', height: '130px' }} />
                      <div style={{ marginTop: '10px', fontWeight: 'bold', fontSize: '20px', fontFamily: 'KanitExtraLight' }}>Integra la gestion<br /> de los CFDI en un solo lugar</div>
                    </div>

                    <div className={`menu-item ${showAnimations ? 'visible' : ''}`} style={{ textAlign: 'center' }}>
                      <img src={AgilizaIcon} alt="Agiliza" style={{ width: '130px', height: '130px' }} />
                      <div style={{ marginTop: '10px', fontWeight: 'bold', fontSize: '20px', fontFamily: 'KanitExtraLight' }}>Agiliza y automatiza<br />los procesos del CFDI</div>
                    </div>

                    <div className={`menu-item ${showAnimations ? 'visible' : ''}`} style={{ textAlign: 'center' }}>
                      <img src={DesicionesIcon} alt="Desiciones" style={{ width: '130px', height: '130px' }} />
                      <div style={{ marginTop: '10px', fontWeight: 'bold', fontSize: '20px', fontFamily: 'KanitExtraLight' }}>Tomar decisiones mas<br />acertadas basadas en datos reales</div>
                    </div>

                    <div className={`menu-item ${showAnimations ? 'visible' : ''}`} style={{ textAlign: 'center' }}>
                      <img src={ReducirIcon} alt="Reducir" style={{ width: '130px', height: '130px' }}/>
                      <div style={{ marginTop: '10px', fontWeight: 'bold',fontSize: '20px', fontFamily: 'KanitExtraLight'}}>Reducir errores que<br />pueden cometerse con <br />la gestion humana</div>
                    </div>

                    <div className={`menu-item ${showAnimations ? 'visible' : ''}`} style={{ textAlign: 'center' }}>
                      <img src={GeneraIcon} alt="Genera" style={{ width: '130px', height: '130px' }} />
                      <div style={{ marginTop: '10px', fontWeight: 'bold', fontSize: '20px', fontFamily: 'KanitExtraLight' }}>Generar informes<br />de los CFDI con datos<br />actualizados</div>
                    </div>

                    <div className={`menu-item ${showAnimations ? 'visible' : ''}`} style={{ textAlign: 'center' }}>
                      <img src={TiempoIcon} alt="Tiempo" style={{ width: '130px', height: '130px' }} />
                      <div style={{ marginTop: '10px', fontWeight: 'bold', fontSize: '20px', fontFamily: 'KanitExtraLight' }}>Ahorra tiempo y costos, mejorando<br />la productividad</div>
                    </div>
                  </div>
                </div>

                {/* Funcionalidades destacadas sección */}
<div className="extra-white-section">
  {/*Titulo Generales*/}
  <h2 className="Generales">Funcionalidades destacadas</h2>
  <div className="extra-white-content">
    <div className="extra-white-text">
      {/* Funcionalidades destacadas */} 

        <div className="texto-bannerdos">
          <span className="negrita-destacada"></span>
  <ul>
    <li>
    Sistema desarrollado en una plataforma de <span className="negrita-destacada">nube</span> pública, con respaldos de información por <span className="negrita-destacada">grupo empresarial</span>.
    </li>
    <li>
     <span className="negrita-destacada">Doble</span> proceso <span className="negrita-destacada">automático</span> para descargar los <span className="negrita-destacada">CFDI</span> vía <span className="negrita-destacada">web service</span> y vía <span className="negrita-destacada">página de internet</span> del SAT.
    </li>
    <li>
     <span className="negrita-destacada">Generación</span> automática de <span className="negrita-destacada">PDF</span> para cada <span className="negrita-destacada">CFDI</span>.
    </li>
    <li>
     <span className="negrita-destacada">Configuración</span> de <span className="negrita-destacada">usuarios</span>, <span className="negrita-destacada">perfiles</span> y <span className="negrita-destacada">permisos</span> para <span className="negrita-destacada">controlar</span> la obtención de información, el procesamiento de datos e ingreso a programas.
    </li>
    <li>
     <span className="negrita-destacada">Multisesión</span> para <span className="negrita-destacada">usuarios</span> dentro de un mismo grupo empresarial.
    </li>
    <li>
    <span className="negrita-destacada">Seguridad</span> y <span className="negrita-destacada">privacidad</span> de los datos de tu grupo empresarial.
    </li>
    <li>
      Acceso directo a los <span className="negrita-destacada">datos</span>, en el <span className="negrita-destacada">momento</span> que lo desees y desde el <span className="negrita-destacada">lugar</span> que te encuentres.
    </li>
    <li>
      Procesa en <span className="negrita-destacada">tiempo real</span> la situación de cualquier tipo de <span className="negrita-destacada">CFDI</span>.
    </li>
    <li>
      Funcionalidad para validar si trabajas con algún <span className="negrita-destacada">RFC</span>  que están dentro de la <span className="negrita-destacada">Lista 69</span>  del SAT.
    </li>
    <li>
     <span className="negrita-destacada">Cubo</span> de datos que permite diseñar <span className="negrita-destacada">informes personalizados</span>.
    </li>
    <li>
     <span className="negrita-destacada">Alerta</span> para informar sobre la <span className="negrita-destacada">descarga</span> de los <span className="negrita-destacada">CFDI</span>.
    </li>
    <li>
     <span className="negrita-destacada">Alerta</span> de <span className="negrita-destacada">solicitudes</span> de <span className="negrita-destacada">cancelación</span>.
    </li>
    <li>
    Configuración de <span className="negrita-destacada">alertas personalizadas</span>.
    </li>
    <li>
     <span className="negrita-destacada">Conciliación avanzada SAT</span> vs <span className="negrita-destacada">ERP</span> de la empresa para cualquier tipo de CFDI.
    </li>
    <li>
     <span className="negrita-destacada">Integración</span> con <span className="negrita-destacada">ERP</span> y desarrollo de <span className="negrita-destacada">API</span>.
    </li>
    <li>
     <span className="negrita-destacada">Interfaz intuitiva</span> y <span className="negrita-destacada">responsiva</span>.
    </li>
    <li>
     <span className="negrita-destacada">Dashboard</span> con indicadores.
    </li>
    <li>
    Basado en las <span className="negrita-destacada">reglas</span> del SAT para <span className="negrita-destacada">descarga</span> de CFDI.
    </li>
    <li>
    <span className="negrita-destacada">Actualizaciones</span> constantes ante <span className="negrita-destacada">cambios</span> normativos.
    </li>
    <li>
    <span className="negrita-destacada">Soporte</span> personalizado.
    </li>
  </ul>
</div>

    </div>
    <div className="extra-white-image">
      {/* Imagen puntos clave */}
      <img src={Grafica} alt="Puntos clave" />
    </div>
  </div>
</div>

{/* Contenedor principal del formulario de contacto*/}
 <div className="formulario-imagen-style20">
  <div className="linea-superior20"></div>

  {/*Titulo Formulario*/}
  <h2>
  {!enviado ? (
    'Contáctanos para más información'
    
  ) : (
    
    <>
    {/* Titulo al enviar*/}
      ¡¡¡ GRACIAS POR CONTACTARNOS !!!<br />
        Un especialista se pondrá en contacto contigo.
    </>
  )}
</h2>

  {!enviado ? (
    <form
      onSubmit={handleSubmit}
      action="https://formsubmit.co/ivan.benitez@iatekza.com"
      method="POST"
      className="formulario-simple20"
    >
      <input type="hidden" name="_captcha" value="false" />
{/* Campos de entrada para nombre, teléfono, correo, empresa y mensaje */}

      {/* Campo nombre*/}
      <input type="text" name="nombre" placeholder="Nombre" required />
      {/* Campo Número Telefónico */}
      <input type="tel" name="numero" placeholder="Número Telefónico" required />
      {/* Campo Correo Electronico*/}
      <input type="email" name="correo" placeholder="Correo Electrónico" required />
      {/* Campo Empresa*/}
      <input type="text" name="empresa" placeholder="Empresa (Opcional)" />
      {/* Campo Mensaje*/}
      <textarea name="mensaje" placeholder="Mensaje" required></textarea>
      {/* Botón de envío del formulario*/}
      <button type="submit">Enviar</button>
    </form>
  ) : (
    <div className="confirmacion-envio20">
      {/* gift al enviar formulario */}
      <img src={checkAnim} alt="Éxito" />
      {/* Texto abajo al enviar*/}
      <p>¡ Mensaje enviado correctamente !</p>
    </div>
  )}
</div>



{/* Contenedor principal  de pie de página con contacto*/}
<div className="contacto-footer-nuevo">
  <div className="footer-contenido-nuevo">
    {/* Fondo completo con redes */}
  <img src={RedesFondo} alt="Fondo redes" className="redes-fondo-completa" />
    {/* Columna 1: Contacto */}
    <div className="footer-columna-nueva">
  <h4>CONTACTO GRUPO IATEKZA</h4>
{/* Ubicación contacto*/}
  <div className="footer-item">
    <img src={Ubi} alt="Ubi" className="footer-icono" />
    <p>Circon 5, Colonia El Pedregal de <br /> Atizapán, Estado de México, C.P. 52948.</p>
  </div>
{/* Numero contacto*/}
  <div className="footer-item">
    <img src={Telefono} alt="Teléfono" className="footer-icono" />
    <p>+52 55 5335 5810</p>
  </div>

{/* Correo contacto*/}
  <div className="footer-item">
    <img src={Email34} alt="Correo" className="footer-icono" />
    <p>ventas@iatekza.com</p>
  </div>
</div>


    {/* Columna 2: Servicios */}
    <div className="footer-columna-nueva">
      <h4>Conoce nuestros servicios</h4>
      <ul>
        {/*Facturacion Electronica Colum 2*/}
        <li><a href="/Facturacion">• Facturación Electronica</a></li>
        {/* Servicio infraestructura TI colum 2*/}
        <li><a href="/Comercializacion">• Infraestructura TI</a></li>
        {/* Servicio Asesoría empresarial colum 2*/}
        <li><a href="/Consultoria">• Asesoría Empresarial</a></li>
        {/* Servicio Soluciones Tecnologicas colum 2*/}
        <li><a href="/Sistemas">• Soluciones Tecnologícas</a></li>
      </ul>
      {/*Facebook Colum 2*/}
      <div className="iconos-redes-nuevos">
        <a href="https://www.facebook.com/profile.php?id=61577085653032&locale=es_LA/" target="_blank" rel="noopener noreferrer">
          <img src={Facebok} alt="Facebook" />
        </a>
        {/*Wasak Colum 2*/}
        <a href="https://api.whatsapp.com/send?phone=5215567786252&text=Hola, me gustaría más información acerca de:" target="_blank" rel="noopener noreferrer">
          <img src={Wasa} alt="WhatsApp" />
        </a>
        {/*Insta Colum 2*/}
        <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
          <img src={insta} alt="Instagram" />
        </a>
      </div>
    </div>

    {/* Columna 3: Información general */}
    <div className="footer-columna-nueva">
      <h4>Información General</h4>
      <ul>
         {/*Sobre Nosotros Colum 3*/}
        <li><a href="/Nosotros">Sobre nosotros</a></li>
         {/*Casos de Exito Colum 3*/}
        <li><a href="/CasosExito">Casos de Éxito</a></li>
        
        <li><a href="/Legal">Aviso Legal</a></li>
        {/*Aviso Legal Colum 3*/}
      </ul>
    </div>
  </div>

{/*Línea de derechos reservados */}
  <div className="footer-bottom-nuevo">
    <p>© Grupo IAtekza 2025 – Todos los derechos reservados</p>
  </div>
</div>






              </>
            } 
          />
          

          
          <Route path="users" element={
            <div style={{ marginTop: "70px", width: "100%", textAlign: 'center' }}>
              <UsersList users={users} onEdit={handleEdit} onDelete={handleDelete} />
              <a
                href="/add-user"
                style={{
                  marginTop: '20px',
                  display: 'block',
                  padding: '10px 20px',
                  backgroundColor: '#D32F2F',
                  color: 'white',
                  textDecoration: 'none',
                  borderRadius: '5px',
                  fontSize: '16px',
                  transition: 'background-color 0.3s',
                }}
                onMouseOver={(e) => (e.target.style.backgroundColor = '#FF5F5F')}
                onMouseOut={(e) => (e.target.style.backgroundColor = '#D32F2F')}
              >
                Agregar nuevo usuario
              </a>
            </div>
          } />
          <Route path="edit/:userId" element={<EditUser />} />
          <Route path="add-user" element={<AddUser />} />
          <Route path="profile" element={<Profile />} />
          <Route path="Facturacion" element={<Facturacion />} />
          <Route path="Servicios" element={<Servicios/>} />
          <Route path="Nosotros" element={<Nosotros/>} />
          <Route path="CasosExito" element={<CasosExito/>} />
          <Route path="Comercializacion" element={<Comercializacion/>} />
          <Route path="Consultoria" element={<Consultoria/>} />
          <Route path="Legal" element={<Legal/>} />
          <Route path="Sistemas" element={<Sistemas/>} />
          <Route path="/caso/:id" element={<PaginaCaso />} />
          <Route path="/catalogo/:id" element={<PaginaCatalogo />} />
        </Route>
      </Routes>
  );
}

export default App;
